import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=db04b888&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=db04b888&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db04b888",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db04b888')) {
      api.createRecord('db04b888', component.options)
    } else {
      api.reload('db04b888', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=db04b888&scoped=true&", function () {
      api.rerender('db04b888', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25dOhK1Wq4b7o/JS/comp/Paginate.vue"
export default component.exports